
// stringify class or instance of a class
// eslint-disable-next-line @typescript-eslint/ban-types
export function stringifyClass(token: object | Function): string {
  if (typeof token === 'object') {
    return token.constructor.name;
  }
  return token.name;
}
